import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyD9up4r5SkOI5R1o670P-9o3YGb_g13k18',
  authDomain: 'my-website-dev-e9c53.firebaseapp.com',
  projectId: 'my-website-dev-e9c53',
  storageBucket: 'my-website-dev-e9c53.appspot.com',
  messagingSenderId: '444120616173',
  appId: '1:444120616173:web:0484de6b3c3cff739590e4',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
